import { API_BASE_URL } from '../config';

const baseUrl= API_BASE_URL;

export const fetchOptions = async (token, language = 'en') => {
  const url = `${baseUrl}options?lang=${language}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Accept-Language": language,
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const json = await response.json();
    return json.data;
  } catch (error) {
    console.error("Failed to fetch options:", error);
    return null;
  }
};

export const fetchPacks = async (token, language = 'en') => {
  const url = `${baseUrl}packs?lang=${language}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Accept-Language": language,
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const json = await response.json();
    return json.data;
  } catch (error) {
    console.error("Failed to fetch packs:", error);
    return null;
  }
};

export const requestPack = async (packId, token, activeStatus = true) => {
  try {
    const response = await fetch(`${baseUrl}users/requestPack?id=${packId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
      body: JSON.stringify({
        active: activeStatus,
        id: packId,
      }),
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Request Pack Error:", error);
    throw error;
  }
};
